// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.login-form-wrapper .login-form-container {
  margin: 0 auto;
  max-width: 570px;
  width: 100%;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 8px 18px -16px rgba(0, 0, 0, 0.19);
  margin-top: 50vh;
  transform: translate(0, -50%);
}
.login-form-wrapper .login-form-container .login-form-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 20px 0;
}
.login-form-wrapper .login-form-container .login-form-description {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  margin: 0 0 40px 0;
  white-space: break-spaces;
  font-weight: 400;
  line-height: 14px;
  font-style: italic;
  color: #3a3f52;
}
.login-form-wrapper .login-form-container .login-form-input {
  width: 100%;
  padding: 13px 22px;
  border-radius: 5px;
  border: 1px solid #dde3ec;
  background: #ffffff;
  font-weight: 300;
  font-size: 16px;
  color: #07074d;
  outline: none;
  resize: none;
}
.login-form-wrapper .login-form-container .login-form-input::placeholder {
  color: #536387;
}
.login-form-wrapper .login-form-container .login-form-input:focus {
  border-color: #6a64f1;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}
.login-form-wrapper .login-form-container .login-form-btn {
  text-align: center;
  width: 100%;
  font-size: 16px;
  border-radius: 5px;
  padding: 14px 25px;
  border: none;
  font-weight: 500;
  background-color: #6a64f1;
  color: white;
  cursor: pointer;
  margin-top: 15px;
}
.login-form-wrapper .login-form-container .login-form-btn:disabled {
  opacity: 0.25;
  pointer-events: none;
}
.login-form-wrapper .login-form-container .login-form-btn:hover {
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}

.login-form {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 30px;
  width: 100%;
  max-width: 400px;
  padding: 20px;
  background: #fff;
}
.login-form .login-form-header {
  text-align: center;
  padding: 10px 0;
  font-size: 20px;
  font-weight: 400;
}
.login-form .login-form-body {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.login-form .login-form-body .login-form-text-field-container {
  position: relative;
}
.login-form .login-form-body .login-form-error-message {
  width: 100%;
  text-align: center;
  margin: 0 0 10px 0;
  padding: 10px;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  border-radius: 4px;
  font-size: 12px;
  color: #721c24;
}
.login-form .forgot-password-link {
  margin-top: 20px;
  color: rgba(33, 37, 41, 0.75);
  font-size: 12px;
  text-decoration: underline;
}
.login-form .sign-up-link {
  margin-top: 5px;
  margin-bottom: 5px;
  overflow: hidden;
  color: #777777;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
}
.login-form .sign-up-link a {
  color: #777777;
  padding: 0;
  font-size: 12px;
  text-decoration: underline;
  font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/views/auth/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EAGA,kDAAA;EACA,gBAAA;EACA,6BAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAN;AAGI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AADN;AAGM;EACE,cAAA;AADR;AAGM;EACE,qBAAA;EACA,2CAAA;AADR;AAKI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAKM;EACE,aAAA;EACA,oBAAA;AAHR;AAMM;EACE,2CAAA;AAJR;;AAYA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AATF;AAWE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AATJ;AAYE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAVJ;AAYI;EACE,kBAAA;AAVN;AAaI;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAXR;AAeE;EACE,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AAbJ;AAgBE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAdJ;AAgBI;EACE,cAAA;EACA,UAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AAdN","sourcesContent":[".login-form-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px;\r\n\r\n  .login-form-container {\r\n    margin: 0 auto;\r\n    max-width: 570px;\r\n    width: 100%;\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 8px 18px -16px rgba(0, 0, 0, 0.19);\r\n    -moz-box-shadow: 0px 8px 18px -16px rgba(0, 0, 0, 0.19);\r\n    box-shadow: 0px 8px 18px -16px rgba(0, 0, 0, 0.19);\r\n    margin-top: 50vh;\r\n    transform: translate(0, -50%);\r\n\r\n    .login-form-title {\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      margin: 0 0 20px 0;\r\n    }\r\n\r\n    .login-form-description {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 10px;\r\n      font-size: 14px;\r\n      margin: 0 0 40px 0;\r\n      white-space: break-spaces;\r\n      font-weight: 400;\r\n      line-height: 14px;\r\n      font-style: italic;\r\n      color: #3a3f52;\r\n    }\r\n\r\n    .login-form-input {\r\n      width: 100%;\r\n      padding: 13px 22px;\r\n      border-radius: 5px;\r\n      border: 1px solid #dde3ec;\r\n      background: #ffffff;\r\n      font-weight: 300;\r\n      font-size: 16px;\r\n      color: #07074d;\r\n      outline: none;\r\n      resize: none;\r\n\r\n      &::placeholder {\r\n        color: #536387;\r\n      }\r\n      &:focus {\r\n        border-color: #6a64f1;\r\n        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\r\n      }\r\n    }\r\n\r\n    .login-form-btn {\r\n      text-align: center;\r\n      width: 100%;\r\n      font-size: 16px;\r\n      border-radius: 5px;\r\n      padding: 14px 25px;\r\n      border: none;\r\n      font-weight: 500;\r\n      background-color: #6a64f1;\r\n      color: white;\r\n      cursor: pointer;\r\n      margin-top: 15px;\r\n\r\n      &:disabled {\r\n        opacity: 0.25;\r\n        pointer-events: none;\r\n      }\r\n\r\n      &:hover {\r\n        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n}\r\n\r\n.login-form {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: auto;\r\n  margin-top: 20px;\r\n  margin-bottom: 30px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  padding: 20px;\r\n  background: #fff;\r\n\r\n  .login-form-header {\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .login-form-body {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n\r\n    .login-form-text-field-container {\r\n      position: relative;\r\n    }\r\n\r\n    .login-form-error-message {\r\n        width: 100%;\r\n        text-align: center;\r\n        margin: 0 0 10px 0;\r\n        padding: 10px;\r\n        background-color: #f8d7da;\r\n        border-color: #f5c6cb;\r\n        border-radius: 4px;\r\n        font-size: 12px;\r\n        color: #721c24;\r\n    }\r\n  }\r\n\r\n  .forgot-password-link {\r\n    margin-top: 20px;\r\n    color: rgba(33, 37, 41, 0.75);\r\n    font-size: 12px;\r\n    text-decoration: underline;\r\n  }\r\n\r\n  .sign-up-link {\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n    overflow: hidden;\r\n    color: #777777;\r\n    padding: 0;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n\r\n    a {\r\n      color: #777777;\r\n      padding: 0;\r\n      font-size: 12px;\r\n      text-decoration: underline;\r\n      font-weight: 300;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
